<template>
	<sf-modal-layout class="qms-xxl" :title="roApcnPopupInfo.title" :show="display" :closeModal="close">
		<div class="sf-actions">
			<div className="sf-actions__left">
				<template v-if="roApcnPopUp.btnApprAuth">
					<!--승인 承认-->
					<sf-button size="sm" v-if="isButton_(scrId, 'CS')" line icon="round-check-on" :onClick="OpenApprPopup3"> <!--:onClick="apprSaveAction"-->
						{{ getMessage_('QWCC001001') }}
					</sf-button>

					<!--기각 驳回-->
					<sf-button size="sm" v-if="isButton_(scrId, 'RJ')" line icon="circle-close" :onClick="OpenApprPopup1">
						{{ getMessage_('QWCC001002') }}
					</sf-button>

					<!--반려 退回-->
					<sf-button size="sm" v-if="isButton_(scrId, 'GV')" line icon="circle-close" :onClick="OpenApprPopup2">
						{{ getMessage_('QWCC001003') }}
					</sf-button>
				</template>

				<template v-if="showGVBtnAlone()"> 
					<sf-button size="sm" v-if="isButton_(scrId, 'GV')" line icon="circle-close" :onClick="OpenApprPopup2">
						{{ getMessage_('QWCC001003') }}
					</sf-button>
				</template>

				<!--임시저장 临时保存-->
				<sf-button size="sm" v-if="roApcnPopUp.btnTsAuth" line icon="file" :onClick="tmpSaveAction">
					{{ getMessage_('QWCC001004') }}
				</sf-button>
				<!--삭제 刪除-->
				<sf-button size="sm" v-if="roApcnPopUp.btnDelAuth" line icon="trash" color="error" :onClick="delAction">
					{{ getMessage_('MWCC000328') }}
				</sf-button>
				<!--신청 申请-->
				<sf-button size="sm" v-if="roApcnPopUp.btnApAuth" line icon="round-check-on" :onClick="appSaveAction">
					{{ getMessage_('QWCC001005') }}
				</sf-button>
			</div>
		</div>

		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-20">
				<template v-if="!isLoading">
					<sf-card class="p-0 border-0 bg-transparent h-100">
						<ro-apcn-popup-table-info1 ref="tableInfo1" :scrId="scrId"></ro-apcn-popup-table-info1>
						<ro-apcn-popup-table-info2
							ref="tableInfo2"
							:sendParam5="sendParam5"
							@OpenPwaApcnPopup="OpenPwaApcnPopup"
							:scrId="scrId"
						></ro-apcn-popup-table-info2>

						<ro-apcn-popup-table-info3
							ref="tableInfo3"
							:sendParam5="sendParam5"
							@OpenPmcPopup="OpenPmcPopup"
							:scrId="scrId"
						></ro-apcn-popup-table-info3>

						<ro-apcn-popup-table-info4
							ref="tableInfo4"
							:sendParam5="sendParam5"
							@OpenCmpnMstPopup="OpenCmpnMstPopup"
							@deletePartList="deletePartList"
							:scrId="scrId"
						></ro-apcn-popup-table-info4>

						<ro-apcn-popup-table-info5
							ref="tableInfo5"
							:scrId="scrId"
							:sendParam1="sendParam1"
							@OpenDelPopup="OpenDelPopup"
							@ChangeStdCst="ChangeStdCst"
							:sendParam2="sendParam2"
							@OpenPopupCommCode="OpenPopupCommCode"
							:sendParam3="sendParam3"
							@OpenCauseCdPopupCommCode="OpenCauseCdPopupCommCode"
							:sendParam6="sendParam6"
							@OpenPopupPartNo="OpenPopupPartNo"
							@DelGridPartNo="DelGridPartNo"
						></ro-apcn-popup-table-info5>

						<ro-apcn-popup-table-info8
							ref="tableInfo8"
							:scrId="scrId"
						></ro-apcn-popup-table-info8>

						<ro-apcn-popup-table-info6
							ref="tableInfo6"
							:scrId="scrId"
							:sendParam4="sendParam4"
							@OpenGridPartPopup="OpenGridPartPopup"
							@ResetCauInfoReset="ResetCauInfoReset"
						></ro-apcn-popup-table-info6>

						<ro-apcn-popup-table-info7 ref="tableInfo7" :scrId="scrId"></ro-apcn-popup-table-info7>

						<ro-apcn-popup-table-info9 ref="tableInfo9" v-if="roApcnCommentList && roApcnCommentList.length > 0" :scrId="scrId"></ro-apcn-popup-table-info9>

						<com-appr-rson-popup ref="apprRsonPop" :scrId="scrId"></com-appr-rson-popup>
						<!--딜러팝업-->
						<comp-popup ref="compPopup" @SendData="sendData1" @Refresh="Refresh" :scrId="scrId" />
						<!--공통팝업-->
						<com-cd-popup ref="comCdPopup" @SendData="sendData2" @Refresh="Refresh" :scrId="scrId" />
						<!--공통팝업-->
						<com-cd-popup ref="comCdPopup1" @SendData="sendData6" @Refresh="Refresh" :scrId="scrId" />
						<!--원인부품팝업-->
						<as-part-popup ref="partPopup" @SendPartData="sendData3" @Refresh="Refresh" :scrId="scrId" />
						<!--원인부품팝업-->
						<as-part-popup ref="partGridPopup" @SendPartData="sendData4" @Refresh="Refresh" :scrId="scrId" />
						<!--PMC팝업-->
						<car-sale-popup ref="pmcNoPopup" @SendPmcData="sendData5" @Refresh="Refresh" :scrId="scrId" />
						<!--기각-->
						<com-appr-rson-popup ref="pmcApprRsonPopup" @apprRsonfresh="apprRsonfresh" :scrId="scrId" />

						<!--캠페인 목록 팝업-->
						<cmpn-mst-popup ref="cmpnMstPopup" :scrId="scrId" @CmpnSelect="CmpnSelect"></cmpn-mst-popup>
						<!--pwa 목록 팝업-->
						<pwa-apcn-list-popup ref="pwaApcnListPopup" :scrId="scrId" @pwaSelectedRow="pwaSelectedRow"></pwa-apcn-list-popup>
					</sf-card>
				</template>
			</div>
		</div>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as Yup from 'yup';

import RoApcnPopupTableInfo1 from './Table/RoApcnPopupTableInfo1.vue';
import RoApcnPopupTableInfo2 from './Table/RoApcnPopupTableInfo2.vue';
import RoApcnPopupTableInfo3 from './Table/RoApcnPopupTableInfo3.vue';
import RoApcnPopupTableInfo4 from './Table/RoApcnPopupTableInfo4.vue';
import RoApcnPopupTableInfo5 from './Table/RoApcnPopupTableInfo5.vue';
import RoApcnPopupTableInfo6 from './Table/RoApcnPopupTableInfo6.vue';
import RoApcnPopupTableInfo7 from './Table/RoApcnPopupTableInfo7.vue';
import RoApcnPopupTableInfo8 from './Table/RoApcnPopupTableInfo8.vue';
import RoApcnPopupTableInfo9 from './Table/RoApcnPopupTableInfo9.vue';
import ComApprRsonPopup from '@qms/comm/commpopup/ComApprRsonPopup/ComApprRsonPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue'; // 딜러점팝업
import ComCdPopup from '@qms/comm/commpopup/ComCdPopup/ComCdPopup.vue'; //공통코드팝업
import AsPartPopup from '@qms/comm/commpopup/AsPartPopup/AsPartPopup.vue'; //원인부품팝업
import CarSalePopup from '@qms/comm/commpopup/CarSalePopup/CarSalePopup.vue'; //PMC팝업
import cmpnMstPopup from '../CmpnMstPopup/CmpnMstPopup.vue'; //캠페인 목록 팝업
import pwaApcnListPopup from '../PwaApcnPopup/PwaApcnListPopup.vue'; //PWA 목록 팝업
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import qmsUtils from '@/store/qms/api'; //변수관리 값 가져오기
import moment from 'moment';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			isLoading: false,
			stdCst: '', //기준금액 담을변수
			roApcnPopupInfo: {
				title: '', //타이틀명
				pwaNo: '', //Pwa번호
				roNo: '', //RO번호
				pmcId: '', //제품ID
				fileList: []
			},
			sendParam1: {}, //딜러펍업
			sendParam2: {}, //공통팝업
			sendParam3: {}, //품번팝업
			sendParam4: {}, //품번팝업
			sendParam5: {}, //PMC팝업
			sendParam6: {} //원인코드팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				//dgnDd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001054')])), //{0}은(는) 팔수 입력 값 입니다. ,  진단일자
				//ceqStrtDd: '', //정비시작일
				//ceqEndDd: '', //정비완료일
				//
				incdCst: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001103')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비

				/*
				wags: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001102')])) ////{0}은(는) 팔수 입력 값 입니다. , 공임비
					.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001102')])),
				*/

				ceqEndDd: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001184')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비
				ceqStrtDd: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001183')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비

				// milg: Yup.number() //주행거리
				// 	.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')])) //{0}은(는) 숫자만 입력 가능합니다. ,  주행거리
				// 	.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC000972')])) //{0}은(는) 양수만 입력 가능합니다. ,  주행거리
				// 	.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC000972'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
				// 	.max(9999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972'), '7'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
				// 	.required(this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972')])), ////{0}은(는) 팔수 입력 값 입니다. ,  주행거리
				milg: Yup.number() //주행거리
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')])) //{0}은(는) 숫자만 입력 가능합니다. ,  주행거리
					.max(9999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972'), '7'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972')])), ////{0}은(는) 팔수 입력 값 입니다. ,  주행거리

				/*
				incdCst: Yup.number()
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001103')])) //{0}은(는) 숫자만 입력 가능합니다. ,  부대비
					.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001103')])) //{0}은(는) 양수만 입력 가능합니다. , 부대비
					.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001103'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
					.max(999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001103'), '3'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001103')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비
				wags: Yup.number()
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001102')])) //{0}은(는) 숫자만 입력 가능합니다. ,  공임비
					.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001102')])) //{0}은(는) 양수만 입력 가능합니다. , 공임비
					.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001102'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
					.max(999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001102'), '3'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001102')])), ////{0}은(는) 팔수 입력 값 입니다. , 공임비
					*/

				//usePrd: Yup.string() //사용기간
				//	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001053')])) ////{0}은(는) 팔수 입력 값 입니다. , 품번
				//	.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001053')])),

				phmnCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001055')])), //{0}은(는) 팔수 입력 값 입니다. ,  현상코드

				dtc3: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				dtc2: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				dtc1: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				ctype: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001056')])), //{0}은(는) 팔수 입력 값 입니다. ,  Ctype
				//occuRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001050')])), //{0}은(는) 팔수 입력 값 입니다. ,  발생지역
				causCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001029')])), //{0}은(는) 팔수 입력 값 입니다. ,  원인코드
				dgnDd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001054')])), //{0}은(는) 팔수 입력 값 입니다. ,  진단일자
				ceqType: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001180')])), //{0}은(는) 팔수 입력 값 입니다. ,  정비유형
				causPartNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001028')])), //{0}은(는) 팔수 입력 값 입니다. ,  원인부품

				dtlRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001051')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역세부
				occuRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001049')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역
				rprRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001050')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역
				dlrCpnyCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000959')])), //{0}은(는) 팔수 입력 값 입니다. ,  딜러점
				pmcId: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001538')])), //{0}은(는) 팔수 입력 값 입니다. , pmc번호
				dtlSbc: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001080')]))
			});
		},
		schemaNormal() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				//dtc3: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				//dtc2: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				//dtc1: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				//dgnDd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001054')])), //{0}은(는) 팔수 입력 값 입니다. ,  진단일자

				incdCst: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001103')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비

				/*
				wags: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001102')])) ////{0}은(는) 팔수 입력 값 입니다. , 공임비
					.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001102')])),
                 */
				// milg: Yup.number() //주행거리
				// 	.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')])) //{0}은(는) 숫자만 입력 가능합니다. ,  주행거리
				// 	.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC000972')])) //{0}은(는) 양수만 입력 가능합니다. ,  주행거리
				// 	.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC000972'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
				// 	.max(9999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972'), '7'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
				// 	.required(this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972')])), ////{0}은(는) 팔수 입력 값 입니다. ,  주행거리
				milg: Yup.number() //주행거리
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')])) //{0}은(는) 숫자만 입력 가능합니다. ,  주행거리
					.max(9999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972'), '7'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972')])), ////{0}은(는) 팔수 입력 값 입니다. ,  주행거리

				/*
				incdCst: Yup.number()
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001103')])) //{0}은(는) 숫자만 입력 가능합니다. ,  부대비
					.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001103')])) //{0}은(는) 양수만 입력 가능합니다. , 부대비
					.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001103'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
					.max(999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001103'), '3'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001103')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비
				wags: Yup.number()
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001102')])) //{0}은(는) 숫자만 입력 가능합니다. ,  공임비
					.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001102')])) //{0}은(는) 양수만 입력 가능합니다. , 공임비
					.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001102'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
					.max(999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001102'), '3'])) //{0}은 최대 {3} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001102')])), ////{0}은(는) 팔수 입력 값 입니다. , 공임비
					*/

				//usePrd: Yup.string() //적용변제금액
				//	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001053')])) ////{0}은(는) 팔수 입력 값 입니다. , 품번
				//		.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001053')])),

				phmnCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001055')])), //{0}은(는) 팔수 입력 값 입니다. ,  현상코드
				//ctype: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001056')])), //{0}은(는) 팔수 입력 값 입니다. ,  Ctype
				//occuRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001050')])), //{0}은(는) 팔수 입력 값 입니다. ,  발생지역
				/*
				dtc3: Yup.string()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')]))
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc2: Yup.string()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')]))
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc1: Yup.string()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')]))
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc
				*/
				dtc3: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				dtc2: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				dtc1: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				ceqEndDd: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001184')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비
				ceqStrtDd: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001183')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비

				causCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001029')])), //{0}은(는) 팔수 입력 값 입니다. ,  원인코드
				dgnDd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001054')])), //{0}은(는) 팔수 입력 값 입니다. ,  진단일자
				ceqType: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001180')])), //{0}은(는) 팔수 입력 값 입니다. ,  정비유형
				causPartNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001028')])), //{0}은(는) 팔수 입력 값 입니다. ,  원인부품
				dtlRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001051')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역세부
				occuRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001049')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역
				rprRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001050')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역
				dlrCpnyCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000959')])), //{0}은(는) 팔수 입력 값 입니다. ,  딜러점
				pmcId: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001538')])), //{0}은(는) 팔수 입력 값 입니다. , pmc번호
				dtlSbc: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001080')]))
			});
		},
		schemaImsi() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				//dtc3: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				//dtc2: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				//dtc1: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])), //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				//dgnDd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001054')])), //{0}은(는) 팔수 입력 값 입니다. ,  진단일자
				dtc3: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])
				), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc2: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])
				), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc1: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])
				), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc

				/*
				wags: Yup.string()
					.nullable()
					.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001102')])),
					*/

				milg: Yup.string()
					.nullable()
					.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')])), //주행거리는 숫자만 입력 가능합니다.

				usePrd: Yup.string() //적용변제금액
					.nullable()
					.matches(/^([0-9]|-1)*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001053')])),

				opCd: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001096')]) //op코드(는) 영문과 숫자만 입력할 수가 있습니다.
				)
			});
		},
		schemaRecord() {
			return Yup.array().of(
				Yup.object().shape({
					/*
					partCst: Yup.number()
						.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001040')])) //{0}은(는) 숫자만 입력 가능합니다. , 부품가격
						.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001040')])) //{0}은(는) 양수만 입력 가능합니다. , 부품가격
						.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001040'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
						.max(9999999999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001040'), '13'])) //{0}은 최대 {7} 자리까지 입력 가능합니다.
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001040')])), ////{0}은(는) 팔수 입력 값 입니다. , 품번

					qty: Yup.number()
						.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000977')])) //{0}은(는) 숫자만 입력 가능합니다. ,  수량
						.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC000977')])) //{0}은(는) 양수만 입력 가능합니다. , 수량
						.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC000977'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
						.max(999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000977'), '3'])) //{0}은 최대 {5} 자리까지 입력 가능합니다.
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000977')])), ////{0}은(는) 팔수 입력 값 입니다. , 수량
					*/

					qty: Yup.string()
						.nullable()
						//.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000977')])) //{0}은(는) 숫자만 입력 가능합니다. ,  교환부품수량
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000977')])), ////{0}은(는) 팔수 입력 값 입니다. , 교환부품수량

					partNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001037')])), //{0}은(는) 팔수 입력 값 입니다. , 수량

					lts: Yup.string()
						.trim()
						.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001100')]))
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001100')])) // 은 필수 입력 항목입니다. , lts
						.matches(/^[.0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC001100')])) //숫자만 입력가능합니다
				})
			);
		},
		schemaImsiRecord() {
			return Yup.array().of(
				Yup.object().shape({
					/*
					partCst: Yup.number()
						.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001040')])) //{0}은(는) 숫자만 입력 가능합니다. , 부품가격
						.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001040')])) //{0}은(는) 양수만 입력 가능합니다. , 부품가격
						.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001040'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
						.max(9999999999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001040'), '13'])) //{0}은 최대 {7} 자리까지 입력 가능합니다.
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001040')])), ////{0}은(는) 팔수 입력 값 입니다. , 품번

					qty: Yup.number()
						.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000977')])) //{0}은(는) 숫자만 입력 가능합니다. ,  수량
						.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC000977')])) //{0}은(는) 양수만 입력 가능합니다. , 수량
						.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC000977'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
						.max(999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000977'), '3'])) //{0}은 최대 {5} 자리까지 입력 가능합니다.
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000977')])), ////{0}은(는) 팔수 입력 값 입니다. , 수량
					*/

					qty: Yup.string()
						.nullable()
						//.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000977')])) //{0}은(는) 숫자만 입력 가능합니다. ,  교환부품수량
						//.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000977')])) ////{0}은(는) 팔수 입력 값 입니다. , 교환부품수량
						.matches(/^[.0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC000977')])), //숫자만 입력가능합니다

					partNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001037')])), //{0}은(는) 팔수 입력 값 입니다. , 수량

					lts: Yup.string()
						.trim()
						.nullable()
						//.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001100')]))
						.matches(/^[.0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC001100')])) //숫자만 입력가능합니다
				})
			);
		},
		schemaOtherFeeRecord() {
			return Yup.array().of(
				Yup.object().shape({
					feeUnit: Yup.string()
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC002143') + this.getMessage_('QWCC001124')])), // 单位
					qty: Yup.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC002143') + this.getMessage_('QWCC001236')])), // 数量	
					unitPrice: Yup.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC002143') + this.getMessage_('QWCC002141')])), // 单价（元）
					feeTypeCd: Yup.string()
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC002143') + this.getMessage_('QWCC002140')])), // 费用类型

				})
			);
		}
	},
	components: {
		RoApcnPopupTableInfo1,
		RoApcnPopupTableInfo2,
		RoApcnPopupTableInfo3,
		RoApcnPopupTableInfo4,
		RoApcnPopupTableInfo5,
		RoApcnPopupTableInfo6,
		RoApcnPopupTableInfo7,
		RoApcnPopupTableInfo8,
		RoApcnPopupTableInfo9,
		ComApprRsonPopup /*기각사유 */,
		CompPopup /*딜러점팝업*/,
		ComCdPopup /*공통팝업*/,
		AsPartPopup /*부품팝업*/,
		CarSalePopup /*PMC팝업*/,
		cmpnMstPopup /*캠페인 목록 팝업*/,
		pwaApcnListPopup /*PWA 목록 팝업*/
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {},
        showGVBtnAlone(){
			return this.roApcnPopUp.prcsStepr == '30' && this.roApcnPopUp.prcsRsltr == '10' && this.roApcnPopUp.outBoundStatus == '0';
		}, 
		makeValidate() {
			const tmpUsePrd = Number(convertNvl(this.saveRoApcn.usePrd, '0')); //사용기간

			const tmpUsePrdPo = Number(convertNvl(this.saveRoApcn.usePrdPo, '0')); //보증사용기간

			const tmpMilg = Number(convertNvl(this.saveRoApcn.milg, '0')); //주행거리

			const tmptmpMilg = Number(convertNvl(this.saveRoApcn.milgPo + '0000', '0')); //보증주행거리 150000

// const erpSaleDd = convertNvl(this.saveRoApcn.erpSaleDd,null); 

			// const jvSaleDd = convertNvl(this.saveRoApcn.jvSaleDd,null); 
			const oemSaleDd = convertNvl(this.saveRoApcn.oemSaleDd,null); 

			//사용기간이 보증기간보다 클경우
			if (tmpUsePrd > tmpUsePrdPo) {
			if(oemSaleDd!=null){
				if (tmpUsePrd > tmpUsePrdPo) {
				this.setStateApcnSave_({ key: 'ceqType', value: '20' }); //정비유형을 일반수리로 변경함.
				this.$refs.tableInfo5.setCeqInfoProcessInfo('20');
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001850'))); // 보증수리 기간이 아닙니다. 일반수리로 변경합니다.'

				}
				//주행거리가 보증사용거리
				//console.log('tmpMilg>>>>>>>>>>>>>>>>', tmpMilg);
				//console.log('tmptmpMilg<>>>>>>>>>>>>>>', tmptmpMilg);
				if (tmpMilg > tmptmpMilg) {
					this.setStateApcnSave_({ key: 'ceqType', value: '20' }); //정비유형을 일반수리로 변경함.
					this.$refs.tableInfo5.setCeqInfoProcessInfo('20');
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001851'))); //'보증 주행거리를 초과하였습니다. 일반수리로 변경합니다.'
				}
			}

			//주행거리가 보증사용거리
			//console.log('tmpMilg>>>>>>>>>>>>>>>>', tmpMilg);
			//console.log('tmptmpMilg<>>>>>>>>>>>>>>', tmptmpMilg);
			if (tmpMilg > tmptmpMilg) {
				this.setStateApcnSave_({ key: 'ceqType', value: '20' }); //정비유형을 일반수리로 변경함.
				this.$refs.tableInfo5.setCeqInfoProcessInfo('20');
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001851'))); //'보증 주행거리를 초과하였습니다. 일반수리로 변경합니다.'
			}

			}

		},
		apprRsonfresh() {
			this.close();
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.roApcnPopupInfo.title = param.title;
			this.roApcnPopupInfo.roNo = param.roNo; //'RO202207300031'; //'RO202207300011'; //param.roNo; //; //param.roNo; /*ro현황에서 디테일 조회시 RO번호가 넘어옴*/
			this.roApcnPopupInfo.pwaNo = param.pwaNo; /*PWA신청 현황에서는 PWANo번호 넘어옴*/
			this.roApcnPopupInfo.pmcId = param.pmcId; /*PWA신청 현황에서는 PmdId 넘어옴*/
			let paramRoNo = this.roApcnPopupInfo.roNo; //'RO202208010001'; //this.roApcnPopupInfo.roNo; //this.roApcnPopupInfo.roNo; //'RO202208010008';
			let paramPwaNo = this.roApcnPopupInfo.pwaNo; //
			let paramPmcId = this.roApcnPopupInfo.pmcId;

			// const ssClassValue = await qmsUtils.getVariableValue(this.user.deptCd);
			// let ssClass = ssClassValue ? ssClassValue.varVal : '';

			// //작업내용 기준금액 가져오기(변수관리에 등록되어있음)
			// const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst'+ssClass);

			// //원인부품 코드에서 그리드로 추가될때 기준금액 셋팅함
			// this.stdCst = rsltVarValue.varVal;

			//초기화
			this.setStateApcnInit_();

			try {
				if (paramRoNo) {
					//console.log('RO상세조회시작 1 문서번호>>>', paramRoNo);

					const searchRoNo = {
						roNo: paramRoNo,
						paramState: ''
					};

					await this.getRoApcnPopList_(searchRoNo);

					await this.setBtnAuth();
				} else if (paramPwaNo) {
					const pwaNoParam = {
						pwaNo: paramPwaNo,
						paramState: ''
					};

					await this.getPwaApcnPopList_(pwaNoParam);

					await this.setBtnAuth();
				} else {
					//console.log('RO번호등록');
					await this.setBtnAuth();
				}
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				//this.close();
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}

			//조회
		},
		setBtnAuth() {
			//임시저장권한
			this.setBtnTsAuth_(this.isButton_(this.scrId, 'TS'));

			//신청권한
			this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));

			//삭제권한
			this.setBtnDelAuth_(this.isButton_(this.scrId, 'CD'));

			//승인권한
			this.setBtnApprAuth_();
		},
		close() {
			this.isLoading = true;
			this.display = false;
		},
		OpenDelPopup(param) {
			//console.log('딜러점 에서의 cmpnCd 값 ::::: ', param.cmpnCd);

			this.$refs.compPopup.open(param); //.open(param);
		},
		OpenPopupCommCode(param) {
			//console.log('공통팝업 에서의 param 값 ::::: ', param);

			this.$refs.comCdPopup.open(param); //.open(param);
		},
		OpenCauseCdPopupCommCode(param) {
			//원인부품코드팝업
			//console.log('공통팝업 에서의 param 값 ::::: ', param);

			this.$refs.comCdPopup1.open(param); //.open(param);
		},
		OpenPopupPartNo(param) {
			//console.log('원인부품팝업 에서의 param 값 ::::: ', param);

			this.$refs.partPopup.open(param); //.open(param);
		},
		OpenGridPartPopup(param) {
			//console.log('교환부품 그리드 팝업 에서의 param 값 ::::: ', param);

			this.$refs.partGridPopup.open(param); //.open(param);
		},
		OpenPmcPopup(param) {
			let openParam = {
				pmcId: param,
				cmpnNo: this.currentCmpnCd,
				roApcnch: true,
				popUpType: 'RO' //제품ID를 가지고 캠페인 명을 가지고 올때 사용함 구분값임
			};

			this.$refs.pmcNoPopup.open(openParam); //.open(openParam);

			/*차량정보조회
			this.getPopupCarSales_(openParam)
				.then(header => {
					this.$refs.pmcNoPopup.open(openParam); //.open(openParam);
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {});
				*/
		},
		OpenPwaNoPopup(param) {
			//console.log('PWA 정보에서 PWA팝업호출시 에서의 param 값 ::::: ', param);

			this.$refs.pmcNoPopup.open(param); //.open(param);
		},
		OpenCamPainPopup(param) {
			//console.log('PWA 정보에서 PWA팝업호출시 에서의 param 값 ::::: ', param);

			this.$refs.pmcNoPopup.open(param); //.open(param);
		},
		OpenApprPopup1() {
			/*기각 驳回*/
			let paramList = {
				apprState: 'G', //기각
				btnMsg: this.getMessage_('QWCC001002'), //기각
				labelMsg: this.getMessage_('QWCC001145'), //기각
				title: this.getMessage_('QWCC001145'), //기각사유
				cfMsg: this.getMessage_('QWCC001149'), //기각하시겠습니까?
				apiType: 'RO',
				masterKey1: this.roApcnPopUp.roNo
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		OpenApprPopup2() {
			/*반려 退回*/
			let paramList = {
				apprState: 'R', //반려
				btnMsg: this.getMessage_('QWCC001003'), //반려
				labelMsg: this.getMessage_('QWCC001146'), //반려
				title: this.getMessage_('QWCC001146'), //반려사유
				cfMsg: this.getMessage_('QWCC001150'), //반려하시겠습니까>?
				apiType: 'RO',
				masterKey1: this.roApcnPopUp.roNo
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		OpenApprPopup3() {
			/*承认*/
			let paramList = {
				apprState: 'A', //기각
				btnMsg: this.getMessage_('QWCC001001'), //기각
				labelMsg: this.getMessage_('MWPE000025'), //기각
				title: this.getMessage_('QWCC001001'), //기각사유
				cfMsg: this.getMessage_('QWCC001155'), //기각하시겠습니까?
				apiType: 'RO',
				notScheme: true,
				masterKey1: this.roApcnPopUp.roNo
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		DelGridPartNo(partNo) {
			let paramList = {
				partNo: partNo //품번
			};

			const paramArray = [paramList];

			this.$refs.tableInfo6.deletePartGridAction(paramArray);
		},
		sendData1(param) {
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			//console.log('result1', param);

			this.sendParam1 = param; //watch감시용
		},
		sendData2(param) {
			//console.log('result2', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.sendParam2 = param; //watch감시용
		},
		sendData6(param) {
			//console.log('원인부품팝업', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.sendParam6 = param; //watch감시용
		},
		ChangeStdCst(value){
			//console.log('stdCst', value);
			if (value !== undefined && value !== '') {
				this.stdCst = value;
				
				const selectedMaps = this.roApcnSwapPartsList.slice();
				// console.log('selectedMaps', selectedMaps);
				const mapData = {};

				selectedMaps.forEach((mapData, index) => {
					// console.log('2>>>>', selectedMaps[index]);
					
					selectedMaps[index].stdCst = this.stdCst;
					selectedMaps[index].wags = Math.round(selectedMaps[index].lts * this.stdCst * 100) / 100;
				});
			}
		},
		sendData3(param) {
			//pwa 기초정보 원인부품팝업전용
			//console.log('result3', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			if (param.asCst == 0) {
				param.zeroGb = true;
			} else {
				param.zeroGb = false;
			}
			if (param.lts == 0) {
				param.ltsZeroGb = true;
			} else {
				param.ltsZeroGb = false;
			}
			//console.log('--------', this.stdCst);
			param.stdCst = this.stdCst; //기준금액셋팅

			this.$refs.tableInfo6.addPartInoGirdAction(param);

			this.sendParam3 = param; //watch감시용
		},
		sendData4(param) {
			//교환부품정보 END품팝업
			//console.log('result4', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			param.stdCst = this.stdCst; //기준금액 셋팅함
			this.$refs.tableInfo6.gridParNoPopUp(param);

			this.sendParam4 = param; //watch감시용
		},
		async sendData5(param) {
			//pmc번호전용

			//console.log('가나다라마바');

			let paramList = {
				oemSaleD: moment(param.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
				dgnDd: convertNvl(this.roApcnPopUp.dgnDd, '') == '' ? moment().format('YYYYMMDD') : moment(this.roApcnPopUp.dgnDd).format('YYYYMMDD') //진단일자
			};

			//사용기간(년)
			await this.getRoUsedYear_(paramList);

			//사용기간(년)셋팅
			this.$refs.tableInfo5.setUsedYearProcessInfo();

			this.sendParam5 = param; //watch감시용
		},
		ResetCauInfoReset(param) {
			//console.log(param);
			this.$refs.tableInfo5.causePartInfoBeforeDataSet(param);
		},
		async afterSaveClose() {
			//팝업창 닫고 재조회
			this.$sf_toggleLoading(true);
			this.close();
			this.$emit('Refresh');
		},
		async tmpSaveAction() {
			//임시저장
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				//console.log('값은>>>>>>>>>>>', this.saveRoApcn);

				// 유효성 검사
				await this.schemaImsi.validateSync(this.saveRoApcn);

				/*
				if (this.roApcnSwapPartsList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
					return;
				}

				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				//let roApcnChekdList = this.$refs.tableInfo6.gridCheckRowData();
				let roApcnChekdList = this.roApcnSwapPartsList;
				await this.schemaRecord.validateSync(roApcnChekdList);
				*/

				await this.schemaImsiRecord.validateSync(this.roApcnSwapPartsList);

				let otherFeeList =  this.$refs.tableInfo8.getTableData();
				if (otherFeeList && otherFeeList.length > 0) {
					await this.schemaOtherFeeRecord.validateSync(otherFeeList);
				}
				

				//PWA 번호가 들어있으면 바로 저장할껄 물어봄
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001157'), //임시저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001004'), clickFn: () => this.save('10') }], //임시저장,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });

				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async appSaveAction() {
			//신청
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				// 유효성 검사
				//PMC번호 입력여부
				//캠페인을 선택할 경우는 하지 않는다.
				const cmpnCd = convertNvl(convertNvl(this.currentCmpnCd, ''), convertNvl(this.saveRoApcn.cmpnNo, ''));

				if (cmpnCd == '') {
					const ceqType = convertNvl(this.saveRoApcn.ceqType, '');

					//보증수리일경우
					if (ceqType == '10') {
						await this.schema.validateSync(this.saveRoApcn);
						await this.makeValidate();
					} else {
						//일반수리일 경우 C/type은 선택하지 않아도 됨
						await this.schemaNormal.validateSync(this.saveRoApcn);
					}

					const ceqStrtDd = this.saveRoApcn.ceqStrtDd;
					const ceqEndDd = this.saveRoApcn.ceqEndDd;

					if (this.$moment(ceqStrtDd).isAfter(this.$moment()) == true) {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001974') //정비시작일은 오늘날짜 이후일자를 선택할수가 없습니다.' ///'정비시작일은 정비완료일 이전 일자로 선택해야됩니다.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
						});

						return false;
					}

					if (this.$moment(ceqEndDd).isAfter(this.$moment()) == true) {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001975') //정비종료일은 오늘날짜 이후일자를 선택할수가 없습니다
						});
						return false;
					}
				} else {
					//currentCmpnStdt: '', //선택한 캠페인 시작일
					//currentCmpnEndDt: '', //선택한 캠페인 종료일

					const cmpnStdt = this.currentCmpnStdt;
					const cmpnEnd = this.currentCmpnEndDt;

					const ceqStrtDd = this.saveRoApcn.ceqStrtDd;
					const ceqEndDd = this.saveRoApcn.ceqEndDd;

					//console.log('캠페인 시작일', cmpnStdt);
					//console.log('캠페인 종료일', cmpnEnd);

					//console.log('정비 시작일', ceqStrtDd);
					//console.log('정비 종료일', ceqEndDd);

					await this.schemaNormal.validateSync(this.saveRoApcn);

					//정비시작일 VALIDATION
					let chkCeqDt = this.saveDateChk(moment(cmpnStdt).format('YYYYMMDD'), moment(cmpnEnd).format('YYYYMMDD'), ceqStrtDd, ceqEndDd);

					//console.log('값은>>>>', chkCeqDt);

					if (!chkCeqDt) {
						throw new Error(this.getMessage_('QWCC002061'));
						//'정비시작일이 캠페인 시작일과 종료일 기간에 속하거나 또는 정비완료일이 캠페인 시작일과 종료일 기간에만 등록가능합니다.'
					}
				}

				//교환부품정보 등록이 되어있나
				if (this.roApcnSwapPartsList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
					return;
				}

				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				let roApcnChekdList = this.roApcnSwapPartsList;

				await this.schemaRecord.validateSync(roApcnChekdList);

				if(!this.saveRoApcn.fileList || this.saveRoApcn.fileList.length == 0){
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001973') });
					return;
				}

				let otherFeeList =  this.$refs.tableInfo8.getTableData();
				if (otherFeeList && otherFeeList.length > 0) {
					await this.schemaOtherFeeRecord.validateSync(otherFeeList);
				}

				const oemSaleDd = convertNvl(this.saveRoApcn.oemSaleDd,null); 
				const milg = convertNvl(this.saveRoApcn.milg,null); 
				
				if(oemSaleDd!=null && milg==0){
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC000972'), '0']) });
					return;
				}
				//const selPwaNo = convertNvl(this.saveRoApcn.pwaNo, '');

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001152'), //신청하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001005'), clickFn: () => this.save('20') }], //신청,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });

				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}

			/*원본
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				// 유효성 검사
				//PMC번호 입력여부
				//캠페인을 선택할 경우는 하지 않는다.
				const cmpnCd = convertNvl(this.currentCmpnCd, '');

				if (cmpnCd == '') {
					const ceqType = convertNvl(this.saveRoApcn.ceqType, '');

					//보증수리일경우
					if (ceqType == '10') {
						await this.schema.validateSync(this.saveRoApcn);
						await this.makeValidate();
					} else {
						//일반수리일 경우 C/type은 선택하지 않아도 됨
						await this.schemaNormal.validateSync(this.saveRoApcn);
					}
				} else {
					//일반수리일 경우 C/type은 선택하지 않아도 됨
					await this.schemaNormal.validateSync(this.saveRoApcn);
				}

				//교환부품정보 등록이 되어있나
				if (this.roApcnSwapPartsList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
					return;
				}

				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				let roApcnChekdList = this.roApcnSwapPartsList;

				await this.schemaRecord.validateSync(roApcnChekdList);

				const selPwaNo = convertNvl(this.saveRoApcn.pwaNo, '');

				//PWA를 선택하지 않으면 기등록된 pwa번호가 있는지 체크함.
				if (selPwaNo === '') {
					//Pwa번호체크
					const chkPwaParam = {
						pmcId: this.saveRoApcn.pmcId,
						causPartNo: this.saveRoApcn.causPartNo,
						milg: this.saveRoApcn.milg
					};

					await this.checkPwa_(chkPwaParam);

					//PMC ID, 원인부품번호, 주행거리로 등록된 PWA번호가 있으면 셋팅함.
					if (this.saveRoApcn.pwaRegCnt > 0) {
						throw new Error(this.getMessage_('QWCC001681'));
					} else {
						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: this.getMessage_('QWCC001152'), //신청하시겠습니까?
							buttons: [{ title: this.getMessage_('QWCC001005'), clickFn: () => this.save('20') }], //신청,
							closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
						});
					}
				} else {
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.getMessage_('QWCC001152'), //신청하시겠습니까?
						buttons: [{ title: this.getMessage_('QWCC001005'), clickFn: () => this.save('20') }], //신청,
						closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
					});
				}


			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });

				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
			*/
		},
		saveDateChk(baseStrDt, baseEndDt, strDt, endDt) {
			let rst = false;
			let a, b, c, d;

			a = Number(baseStrDt);
			b = Number(baseEndDt);
			c = Number(strDt);
			d = Number(endDt);

			//console.log('a', a);
			//console.log('b', b);
			//console.log('c', c);
			//console.log('d', d);

			// 정비시작일이 캠페인 시작일과 종료일 기간에 속하거나 또는 정비완료일이 캠페인 시작일과 종료일 기간에만 등록가능합니다.

			if (a <= c && c <= b) {
				rst = true;
				//등록가능
			} else {
				rst = false;
				//등록불가
			}

			if (!rst) {
				if (a <= d && d <= b) {
					rst = true;
					//등록가능
				} else {
					rst = false;
					//등록불가
				}
			}

			return rst;
		},
		async apprSaveAction() {
			//승인처리
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				/*
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprSave() }], //승인,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
				*/

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprDupCnt() }], //승인,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async apprDupCnt() {
			//승인처리
			await this.apprDupCnt_()
				.then(response => {
					//console.log('>>>>>>>>>>', response);

					if (response.body.confirmYn == 'N') {
						if (response.header.message != undefined && response.header.message != null) {
							if (response.header.code === 0) {
								//승인처리한다.
								this.apprSave();
							} else {
								this.$sf_toast({
									type: response.header.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(response.header.messageCd)
								});
							}
						}
					} else {
						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: this.getMessage_(response.header.messageCd), //승인하시겠습니까?
							buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprSave() }], //승인,
							closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		async delAction() {
			//삭제
			await this.setState_({ key: 'isSaveFlag', value: true });

			/*삭제파람*/
			const delParam = {
				roNo: this.roApcnPopUp.roNo,
				roFileId: convertNvl(this.roApcnPopUp.roFileId, '')
			};

			try {
				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000328'), clickFn: () => this.delete(delParam) }], //삭제
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async save(paramState) {
			//저장
			let formData = new FormData();

			//State를 formData에 Key Value로 넣습니다.
			//폼객체에 API 구분값을 담는다.
			Object.keys(this.saveRoApcn).forEach(key => formData.append(key, convertNvl(this.saveRoApcn[key], '')));

			//첨부파일 fileList로 바뀜
			if (this.saveRoApcn.fileList.length > 0) this.saveRoApcn.fileList.forEach(element => formData.append('fileList', element));
			else formData.append('fileList', '');

			/*fromData 찍어보기
			var object = {};
			formData.forEach((value, key) => (object[key] = value));
			var json = JSON.stringify(object);

			//console.log('formData>>>>>>>>>>', json);
			*/
			//return false;

			if (this.roApcnSwapPartsList.length > 0) {
				this.roApcnSwapPartsList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						formData.append('partList[' + index + '].' + key, element[key]);
					});
				});
			} else {
				formData.append('partList', '');
			}
			
			let otherFeeList =  this.$refs.tableInfo8.getTableData();
			if (otherFeeList && otherFeeList.length > 0) {
				otherFeeList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						if(element[key]){
							formData.append('otherFeeList[' + index + '].' + key, element[key]);
						}
					});
				});
			} else {
				formData.append('otherFeeList', '');
			}
			
			/*fromData 찍어보기
			var object = {};
			formData.forEach((value, key) => (object[key] = value));
			var json = JSON.stringify(object);

			//console.log('formData>>>>>>>>>>', json);

			return false;
			*/

			//교환부품
			// 다돌리는거
			/*
			if (this.roApcnSwapPartsList.length > 0) {
				this.roApcnSwapPartsList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						let tmpVal = element[key];

						if (tmpVal != null) {
							formData.append('partList[' + index + '].' + key, element[key]);
						}
					});
				});
			} else {
				formData.append('partList', '');
			}
			*/

			//교환부품 체크로 선택한 데이터만 가지고 온다.
			//let roApcnChekdList = this.$refs.tableInfo6.gridCheckRowData();

			//console.log('pwaApcnChekdList', pwaApcnChekdList);

			//교환부품셋팅
			/*
			if (roApcnChekdList.length > 0) {
				roApcnChekdList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						formData.append('partList[' + index + '].' + key, element[key]);
					});
				});
			} else {
				formData.append('partList', '');
			}
			*/
			//paramState값은 10은 임시저장, 20번 신청
			formData.append('state', paramState);

			await this.saveRoApcnPopup_({ formData })
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					//여기부터
					this.setState_({ key: 'beRoNo', value: response.body.roNo });
					this.setState_({ key: 'bePrcsStepr', value: response.body.prcsStepr });
					this.setState_({ key: 'bePrcsStempNmr', value: response.body.prcsStepNmr });

					//임시저장후
					//재조회를 한후 처리상태 컴포넌트에 pwaNo. 처리단계 신청일 확정일등을
					//임시저장상태
					if (paramState === '10') {
						//alert('값이뭐냐' + response.body.roNo);

						const roNoParam = {
							roNo: response.body.roNo,
							paramState
						};

						/*저장된거 다시조회*/
						this.getRoApcnPopList_(roNoParam).then(response => {
							//다시 셋팅함.
							this.$refs.tableInfo1.setProcessInfo();
							this.$refs.tableInfo2.setProcessInfo();
							this.$refs.tableInfo3.setProcessInfo();
							this.$refs.tableInfo4.setProcessInfo();
							this.$refs.tableInfo5.setProcessInfo();
							this.$refs.tableInfo7.setProcessInfo();
						});

						this.$emit('Refresh');
					} else {
						//모달창 닫고 재조회
						this.afterSaveClose();
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async apprSave() {
			//승인처리
			await this.saveStateAppr_()
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
					//모달창 닫고 재조회 정상일경우
					if (response.header.code === 0) {
						this.afterSaveClose();
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		// async checkPwa(chkPwaArgs) {
		// 	//console.log('delParam>>>', delParam);

		// 	await this.checkPwa_(chkPwaArgs)
		// 		.then(response => {
		// 			if (response.header.message != undefined && response.header.message != null) {
		// 				return response.body.pwaRegCnt;
		// 			}
		// 		})
		// 		.catch(error => {
		// 			return error;
		// 		})

		// },

		async delete(delParam) {
			await this.deleteRoApcnPopup_(delParam)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					//모달창 닫고 재조회
					this.afterSaveClose();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		/*******************************************얼그레이아이스티 ******************************/

		//PWA 현황 조회 팝업
		OpenPwaApcnPopup(pwaNo) {
			const param = {
				title: this.getMessage_('QWCC001192'),
				pwaNo: pwaNo,
				popUpType: 'RO' //팝업호출구분값 :RO 또는 PWA
			};
			this.$refs.pwaApcnListPopup.open(param);
		},
		//캠페인 목록 조회 팝업
		OpenCmpnMstPopup(cmpnNo) {
			//console.log('선택한 PMCID>?>', this.selectedPmcId);

			const param = {
				title: this.getMessage_('QWCC001178'),
				cmpnNo: cmpnNo,
				pmcId: this.selectedPmcId
			};
			this.$refs.cmpnMstPopup.open(param);
		},
		async CmpnSelect() {
			await this.$refs.tableInfo5.resetCtype1();
			await this.$refs.tableInfo4.seletedCmpnNo();
			await this.$refs.tableInfo5.changeCmpn();
		},
		async pwaSelectedRow(row) {
			const tmpCmpnoList = convertNvl(row.cmpnNoList, '');

			//제품번호를 가지고 캠페인 리스트를 조회함 (Carsales팝업에서 조회를 해온다.)
			if (tmpCmpnoList != '') {
				this.$sf_showMessage({
					icon: 'ok',
					message: this.getMessage_('QWCC001928') + ' [' + tmpCmpnoList + ']',
					clickFn: this.selectedPwaIdSetData(row)
				});

				//return false;
			} else {
				this.selectedPwaIdSetData(row);
			}
		},
		async selectedPwaIdSetData(row) {
			const pwaNoParam1 = {
				pwaNo: row.pwaNo,
				paramState: ''
			};

			this.$refs.tableInfo4.ondeleteCmpnNo();
			this.$refs.tableInfo5.resetCtype1();
			await this.getPwaApcnPopList_(pwaNoParam1).then(response => {
				//다시 셋팅함.
				this.$refs.tableInfo1.setProcessInfo();
				this.$refs.tableInfo2.setProcessInfo();
				this.$refs.tableInfo3.setProcessInfo();
				this.$refs.tableInfo4.setProcessInfo();
				this.$refs.tableInfo5.setProcessInfo();
				this.$refs.tableInfo7.setProcessInfo();
			});

			await this.setBtnAuth();
		},
		/*,원본
		async pwaSelectedRow(row) {
			const tmpCmpnoList = convertNvl(row.cmpnNoList, '');

			//제품번호를 가지고 캠페인 리스트를 조회함 (Carsales팝업에서 조회를 해온다.)
			if (tmpCmpnoList != '') {

				this.$sf_toast({
					type: 'error',
					message: this.getMessage_('QWCC001928') + tmpCmpnoList //'캠페인대상입니다.\n'
				});



				//return false;
			} else {
				const pwaNoParam1 = {
					pwaNo: row.pwaNo,
					paramState: ''
				};

				this.$refs.tableInfo5.resetCtype1();
				await this.getPwaApcnPopList_(pwaNoParam1).then(response => {
					//다시 셋팅함.
					this.$refs.tableInfo1.setProcessInfo();
					this.$refs.tableInfo2.setProcessInfo();
					this.$refs.tableInfo3.setProcessInfo();
					this.$refs.tableInfo4.setProcessInfo();
					this.$refs.tableInfo5.setProcessInfo();
					this.$refs.tableInfo7.setProcessInfo();
				});

				await this.setBtnAuth();
			} //end if
		}*/ deletePartList() {
			this.$refs.tableInfo6.deletePartList();
			this.$refs.tableInfo5.deleteCmpn();
		}
	},
	/*******************************************얼그레이아이스티 ******************************/
	created() {
		console.clear();
		//console.log('값은', this.scrId);
	}
};
</script>

<style></style>
